<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-27 23:57:16
 * @LastEditTime: 2019-09-28 18:16:06
 * @LastEditors: Please set LastEditors
 -->
<template>
  <el-dialog
    class="upModal"
    title="停用特殊账户"
    :close-on-click-modal="false"
    :visible="blockup.state"
    width="1000px"
    :modal="false"
    @close="closeModal()"
  >
    <div class="blockup">
      <div class="mueTree">
        <div class="choice span">选择人员转移部门</div>
        <treeMenu
          ref="treeMenu"
          initId="0"
          :showBox="false"
          :showArrow="false"
          loadStyle="staticLoad"
          style="width: 30%; dispaly: inline-block"
          @nodeClick="getNodeId"
        ></treeMenu>
      </div>
      <div class="user">
        <div class="choice-role">
          <span class="span">选择角色</span>
          <div class="search_wrapper">
            <div>
              <el-input
                v-model="roleName"
                placeholder="角色名搜索"
                style="width: 150px; margin-right: 10px"
                @keyup.enter.native="search"
              />
              <el-button type="primary" size="small " @click="search()">
                <i class="el-icon-search"></i><span>搜索</span>
              </el-button>
              <el-button size="small " @click="clearSearch()"
                ><i class="el-icon-refresh"></i><span>清空</span>
              </el-button>
            </div>
          </div>
        </div>

        <div class="choice-table">
          <el-table
            v-loading="tableLoading"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            header-row-class-name="table-head"
            class="table"
          >
            <el-table-column type="selection" width="55" align="center">
            </el-table-column>
            <el-table-column
              type="index"
              label="序号"
              width="65"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="roleName"
              label="角色名称"
              width="140"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="roleCode"
              label="角色标识"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="roleDesc"
              label="角色描述"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="roleDesc"
              label="角色类型"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>教师</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="createTime"
              label="创建时间"
              align="center"
              width="170"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
          <div style="margin-top: 20px; text-align: right">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="current"
              layout="total,sizes,prev, pager, next"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">取 消</el-button>
      <el-button type="primary" @click="stop" :loading="loading"
        >停 用</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import treeMenu from "@/components/treeMenu/index.vue";
import { getRoleTableData } from "@/api/system/role";
import { endUsing } from "@/api/management/user";
export default {
  props: {
    blockup: {
      type: Object,
      required: true,
    },
  },
  components: { treeMenu },
  data() {
    return {
      loading: false,
      tableData: [],
      tableLoading: false,
      current: 1,
      pageSize: 10,
      total: 0,
      roleName: "",
      params: {
        deptId: "",
        deptName: "",
        roleId: "",
        userId: "",
      },
    };
  },
  computed: {},
  created() {
    this.getTableData();
  },
  methods: {
    // 获取表格数据
    getTableData() {
      this.tableLoading = true;
      let params = {
        size: this.pageSize,
        current: this.current,
        type: 0,
      };
      if (this.roleName) {
        params.keywords = this.roleName;
      }
      getRoleTableData(params).then((res) => {
        if (res.data.code == 0) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.records;
        } else {
          this.$message.error(res.data.msg);
        }
        this.tableLoading = false;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getTableData();
    },
    closeModal() {
      this.$emit("close");
    },
    handleSelectionChange(selection) {
      if (selection.length > 0) {
        this.params.roleId = selection[0].roleId;
      }
      if (selection.length > 1) {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleRowSelection(selection.pop());
      }
    },
    // 搜索
    search() {
      this.current = 1;
      this.getTableData();
    },
    // 清空搜索
    clearSearch() {
      this.roleName = "";
      this.getTableData();
    },
    getNodeId(data) {
      this.params.deptId = data.id;
      this.params.deptName = data.name;
    },
    async stop() {
      if (
        this.params.deptId == "" ||
        this.params.deptId == null ||
        this.params.deptId == undefined
      ) {
        this.$message.error("请选择人员转移部门");
        return;
      }
      if (
        this.params.roleId == "" ||
        this.params.roleId == null ||
        this.params.roleId == undefined
      ) {
        this.$message.error("请选择角色");
        return;
      }
      this.loading = true;
      this.params.userId = this.blockup.userId;
      const { data } = await endUsing(this.params);
      this.loading = false;
      if (data.code == 0) {
        this.$message.success("停用成功");
        this.$emit("close", true);
      } else {
        this.$message.error(data.msg);
      }
    },
  },
  watch: {
    "blockup.state"(newval) {
      if (newval) {
        this.$nextTick(() => {
          this.$refs.multipleTable.clearSelection();
          this.roleName = ''
          this.params.roleId = ''
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.upModal {
  .blockup {
    width: 100%;
    display: flex;
    height: 56vh;
  }
  .mueTree {
    .tree_box {
      width: 100% !important;
      height: calc(100% - 50px);
    }
  }
  .choice {
    height: 50px;
  }
  .span {
    line-height: 50px;
    font-size: 14px;
    font-weight: bold;
  }
  .user {
    flex: 1;
    padding-left: 20px;
    box-sizing: border-box;
    .choice-role {
      display: flex;
      justify-content: space-between;
      height: 50px;
      align-items: center;
    }
  }
  .choice-table {
    height: calc(100% - 50px);
    box-shadow: 0 0 10px 0 #e4e7ed;
  }
  .table {
    height: calc(100% - 52px);
    overflow-y: auto;
  }
}
/deep/thead .el-table-column--selection .cell {
  display: none;
}
</style>